export const ROUTE_MODES = {
	HISTORY: 'history',
	ABSTRACT: 'abstract',
	HASH: 'hash'
};
